// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_g7Y5B"};